var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"More-text"},[_c('router-link',{attrs:{"to":_vm.to}},[_vm._v(_vm._s(_vm.$t("pages.pricing.learnMore.learnMore"))+" →")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }